import { getCookie } from 'h3';

export default defineNuxtPlugin((nuxtApp) => {

  const theme = ref<'light' | 'dark'>('light')
  const themeOption = ref<'light' | 'dark' | 'system'>('light')

  // On server-side: read cookies to set initial theme
  if (import.meta.server) {
    const event = useRequestEvent();
    if(event) {
      const cookieTheme = getCookie(event, 'theme');
      if (cookieTheme) {
        theme.value = cookieTheme;
        useHead({
          htmlAttrs: { 'data-theme': theme.value },
        });
      }
      const cookieThemeOption = getCookie(event, 'themeOption');
      if (cookieThemeOption) {
        themeOption.value = cookieThemeOption;
      }
    }
  }

  // On client-side: sync theme to DOM and persist it
  if (import.meta.client) {
    let savedTheme =
      localStorage.getItem('theme') ||
      document.cookie.replace(/(?:(?:^|.*;\s*)theme\s*\=\s*([^;]*).*$)|^.*$/, '$1') ||
      (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');

    themeOption.value = localStorage.getItem('themeOption') ||
      document.cookie.replace(/(?:(?:^|.*;\s*)themeOption\s*\=\s*([^;]*).*$)|^.*$/, '$1') ||
      'system';

    document.documentElement.setAttribute('data-theme', savedTheme);
    document.cookie = `theme=${savedTheme};path=/;max-age=31536000`;
    theme.value = savedTheme;

    const setTheme = (t: string) => {
      themeOption.value = t;
      if(t === 'system') {
        t = (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
      }
      theme.value = t;
      document.documentElement.setAttribute('data-theme', theme.value);
      localStorage.setItem('theme', theme.value);
      localStorage.setItem('themeOption', themeOption.value);
      document.cookie = `theme=${theme.value};path=/;max-age=31536000`;
      document.cookie = `themeOption=${themeOption.value};path=/;max-age=31536000`;
    };

    nuxtApp.provide('theme', {
      set: setTheme,
      current: theme,
      currentOption: themeOption
    });
  }
});
